<template>
  <div class="teachings mt-8">
    <section>
      <div class="mx-auto px-4 py-12 md:container lg:px-12 lg:py-24 xl:px-3">
        <h1 class="text-color-1 mb-4 text-center text-3xl font-bold md:text-5xl">
          Timeless Teachings
        </h1>
        <p class="mb-16 text-center">
          No one and no thing can ensure a secured life except heightened awareness of yourself.
        </p>
        <div class="grid gap-16 md:grid-cols-2 lg:grid-cols-3">
          <Card
            v-for="(post, index) in blogs"
            :key="index"
            :image="post.image"
            :title="post.title"
            :description="post.description"
            :author="post.author"
            :publish-date="post.publishDate"
            :nav-to="post._path"
          />
        </div>
      </div>
    </section>
  </div>
</template>

<script setup lang="ts">
const { data: blogs } = await useAsyncData('blogs-query', () =>
  queryContent('/blog').where({ active: true }).sort({ order: 1, $numeric: true }).find()
);

useHead({
  title: 'Timeless Teachings',
});
</script>

<style lang="scss" scoped>
.teachings {
}
</style>
